<template>
  <v-container>
    <template v-if="user.first_name">
      <p class="text-center">
        Hi {{ user.first_name }}! This is the fed kitchen app.
      </p>
      <v-img
          class="home-meal-image mx-auto"
          aspect-ratio="1"
          max-width="60vh"
          :src="mealImageUrl || placeholderImage"
          :lazy-src="placeholderImage"
      />
      <p class="text-center">
        <template v-if="randomMeal">
          {{ randomMeal.name }}
          <template v-if="streamName"> - {{ streamName }}</template>
          - {{ dateFormatted(randomMeal.date) }}
        </template>
        <template v-else-if="loadingMealImage">
          finding a tasty upcoming meal...
        </template>
        <template v-if="joke">
          <br/><br/>
          {{ joke }} (<a href="https://icanhazdadjoke.com">attribution</a>)
        </template>
      </p>

    </template>
    <h1 v-if="user.none">Please login to continue
      <router-link to="login">Login</router-link>
    </h1>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import axios from 'axios';
import moment from 'moment';
import {dateFormatted} from '@/store/utils';
import placeholderImage from '@/assets/photo-coming.jpg';

function shuffle(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

export default {
  name: "Home",
  computed: {
    ...mapGetters([
      'getCurrentUser',
      'getDietStream',
      'getStreamName'
    ]),
    user() {
      console.log('user ', this.getCurrentUser);
      return this.getCurrentUser;
    },
    streamName() {
      return this.randomMeal && this.getStreamName(this.getDietStream(this.randomMeal.diet));
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(user) {
        if (user && user.first_name) {
          this.loadRandomMealImage();
        }
      }
    }
  },
  mounted() {
    axios
        .get('https://icanhazdadjoke.com/',
            {
              headers: {
                Accept: 'text/plain'
              }
            })
        .then(j => this.joke = j.data);
  },
  methods: {
    ...mapActions([
      'fetchUpcomingProductions',
      'fetchDiets',
      'fetchStreams',
      'fetchMeals',
      'fetchMeal'
    ]),
    dateFormatted,
    async loadRandomMealImage() {
      if (this.mealImageUrl || this.loadingMealImage) {
        return;
      }
      this.loadingMealImage = true;
      try {
        const [productions] = await Promise.all([
          this.fetchUpcomingProductions(),
          this.fetchDiets(),
          this.fetchStreams()
        ]);
        const today = moment().startOf('day');
        const cutoff = moment(today).add(7, 'days');
        const upcomingDates = [...new Set((productions || []).flatMap(p => p.dates))]
            .filter(date => moment(date).isBetween(today, cutoff, 'day', '[]'));
        for (const date of shuffle(upcomingDates)) {
          const meals = await this.fetchMeals(date);
          for (const meal of shuffle(meals || [])) {
            const detail = await this.fetchMeal(meal.id).catch(e => {
              console.warn('failed to fetch meal ' + meal.id, e.message);
            });
            const plated = detail && detail.sku_images && detail.sku_images.plated;
            if (plated && plated.url) {
              // list row wins for name/date/diet: detail dates are full timestamps
              this.randomMeal = {...detail, ...meal};
              this.mealImageUrl = plated.url;
              return;
            }
          }
        }
        console.warn('no upcoming meal with a plated image found', upcomingDates);
      } catch (e) {
        console.error('failed to load random meal image', e);
      } finally {
        this.loadingMealImage = false;
      }
    }
  },
  data() {
    return {
      joke: null,
      placeholderImage,
      loadingMealImage: false,
      mealImageUrl: null,
      randomMeal: null
    }
  }
}
</script>

<style scoped>
/* match the fed-web meal card look: rounded corners, cover-cropped with a slight zoom */
.home-meal-image {
  border-radius: 17px;
}

.home-meal-image ::v-deep .v-image__image {
  transform: scale(1.05);
}
</style>
